import { useNavigate } from "react-router-dom";
import ROUTERS from '../../../../commons/constans/router';
import { ReactComponent as IconNextBtnPurple } from '../../../../assets/images/icon_next_btn_Purple.svg';
type props = {};

const ParticipateInVotingComponent = ({}: props) => {
  const navigate = useNavigate();

  const goToAwardVote = () => {
    navigate(ROUTERS.AWARD_VOTING)
  }

  return (
    <div className="awards-participate-voting">
      <div className="awards-participate-voting__title">
        <h3 className="awards-participate-voting__title__text">
          나도 투표 참여하기
        </h3>
        <p className="awards-participate-voting__title__description">
          이달의 스포키즈에 투표해주세요!
        </p>
      </div>
      <div className="awards-participate-voting__step">
        <div className="participate-voting-step-item">
          <h4 className="participate-voting-step-item__text">STEP 1</h4>
          <div className="participate-voting-step-item__right-content">
            <span>
              투표권은 <strong>총 2장</strong> 입니다
            </span>
          </div>
        </div>
        <div className="participate-voting-step-item">
          <h4 className="participate-voting-step-item__text ">STEP 2</h4>
          <div className="participate-voting-step-item__right-content">
            <span>
              2명의 <strong>스포키즈를 선택</strong>하세요.
            </span>
            <label className="note-step">
              1명만 투표하는 것은 불가능합니다.
            </label>
          </div>
        </div>
        <div className="participate-voting-step-item">
          <h4 className="participate-voting-step-item__text">STEP 3</h4>
          <div className="participate-voting-step-item__right-content">
            <span>
              하단의 <strong>투표하기 버튼</strong>을 눌러 투표를 완료해주세요
            </span>
          </div>
        </div>
      </div>
      <div className="awards-participate-voting__link text-center">
        <button className="btn btn-rounded  btn-primary btn-light" onClick={goToAwardVote}>
          <label>투표 하러가기</label>
          <IconNextBtnPurple />
        </button>
      </div>
    </div>
  );
};

export default ParticipateInVotingComponent;
